import { useEffect, useState } from "react";
import styled from "styled-components";

import * as UI from "../../../../../../modules/ui-kit";
import ComponentTypeSelector from "../../entities/component-type/ComponentTypeSelector";
import Properties from "../Properties";

const Styled = styled.div`
    display: flex;
    flex-direction: column;
    gap: 32px;
`;

export default function LayerDetail(props) {
    const {
        bimClassID,
        componentTypeID,
        onChange,
        onClose,
        properties,
    } = props;

    const [updatedComponentTypeID, setComponentTypeID] = useState(undefined);
    useEffect(
        () => setComponentTypeID(componentTypeID),
        [componentTypeID],
    );

    const [updatedProperties, setProperties] = useState(undefined);
    useEffect(
        () => setProperties(properties),
        [properties],
    );

    function onSubmit(event) {
        event.preventDefault();

        const update = {};
        if (updatedComponentTypeID !== undefined) update.componentType = { id: updatedComponentTypeID };
        if (updatedProperties !== undefined) update.properties = updatedProperties;

        onChange(update);
        onClose();
    }

    return (
        <Styled>
            <ComponentTypeSelector
                bimClassID={ bimClassID }
                onChange={ setComponentTypeID }
                value={ updatedComponentTypeID }
            />
            <Properties
                onChange={ setProperties }
                value={ updatedProperties ?? [] }
            />
            <UI.Button
                $appearance="primary"
                onClick={ onSubmit }
            >
                Save
            </UI.Button>
        </Styled>
    );
}
